import { useState } from "react";
import "./editorialForms.css";

export default function SchoolForm({ data, onChange }) {
  const [courseInput, setCourseInput] = useState("");

  const postTypes = [
    { id: "announcement", name: "Comunicado" },
    { id: "event", name: "Evento" },
    { id: "enrollment", name: "Matrícula" },
    { id: "calendar", name: "Calendário" },
    { id: "achievement", name: "Conquista" },
    { id: "job", name: "Vaga" },
    { id: "news", name: "Notícia" },
    { id: "course", name: "Curso/Oficina" },
  ];

  const institutionTypes = [
    { id: "school", name: "Escola" },
    { id: "university", name: "Universidade" },
    { id: "college", name: "Faculdade" },
    { id: "technical", name: "Escola Técnica" },
    { id: "language", name: "Escola de Idiomas" },
    { id: "online", name: "Plataforma Online" },
    { id: "training", name: "Centro de Treinamento" },
  ];

  const targetAudiences = [
    "Estudantes",
    "Pais/Responsáveis",
    "Professores",
    "Funcionários",
    "Comunidade",
    "Ex-alunos",
    "Todos",
  ];

  const handleAddCourse = () => {
    if (courseInput.trim()) {
      onChange({
        ...data,
        courses: [...(data?.courses || []), courseInput.trim()],
      });
      setCourseInput("");
    }
  };

  const handleRemoveCourse = (index) => {
    onChange({
      ...data,
      courses: (data?.courses || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form school_form">
      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Inscrições Abertas para 2025"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Conteúdo</label>
        <textarea
          placeholder="Detalhes do comunicado..."
          value={data?.content || ""}
          onChange={(e) => onChange({ ...data, content: e.target.value })}
          maxLength={3000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Publicação</label>
          <select
            value={data?.postType || "announcement"}
            onChange={(e) => onChange({ ...data, postType: e.target.value })}
          >
            {postTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Tipo de Instituição</label>
          <select
            value={data?.institutionType || "school"}
            onChange={(e) => onChange({ ...data, institutionType: e.target.value })}
          >
            {institutionTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Nome da Instituição</label>
        <input
          type="text"
          placeholder="Ex: Colégio São Paulo"
          value={data?.institutionName || ""}
          onChange={(e) => onChange({ ...data, institutionName: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Público-Alvo</label>
          <select
            value={data?.targetAudience || "Todos"}
            onChange={(e) => onChange({ ...data, targetAudience: e.target.value })}
          >
            {targetAudiences.map((aud) => (
              <option key={aud} value={aud}>
                {aud}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Prioridade</label>
          <select
            value={data?.priority || "normal"}
            onChange={(e) => onChange({ ...data, priority: e.target.value })}
          >
            <option value="low">Baixa</option>
            <option value="normal">Normal</option>
            <option value="high">Alta</option>
            <option value="urgent">Urgente</option>
          </select>
        </div>
      </div>

      {(data?.postType === "event" || data?.postType === "enrollment") && (
        <div className="editorial_form_row">
          <div className="editorial_form_section">
            <label>Data de Início</label>
            <input
              type="datetime-local"
              value={data?.startDate || ""}
              onChange={(e) => onChange({ ...data, startDate: e.target.value })}
            />
          </div>
          <div className="editorial_form_section">
            <label>Data de Término</label>
            <input
              type="datetime-local"
              value={data?.endDate || ""}
              onChange={(e) => onChange({ ...data, endDate: e.target.value })}
            />
          </div>
        </div>
      )}

      <div className="editorial_form_section">
        <label>
          Cursos/Áreas Relacionadas
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddCourse}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Engenharia, Medicina..."
          value={courseInput}
          onChange={(e) => setCourseInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddCourse()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.courses || []).map((course, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveCourse(i)}
              style={{ cursor: "pointer" }}
            >
              {course} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Contato</label>
        <div className="editorial_form_row">
          <input
            type="email"
            placeholder="Email"
            value={data?.contactEmail || ""}
            onChange={(e) => onChange({ ...data, contactEmail: e.target.value })}
          />
          <input
            type="tel"
            placeholder="Telefone"
            value={data?.contactPhone || ""}
            onChange={(e) => onChange({ ...data, contactPhone: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Link Externo</label>
        <input
          type="url"
          placeholder="https://www.escola.com.br/inscricoes"
          value={data?.externalLink || ""}
          onChange={(e) => onChange({ ...data, externalLink: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Configurações</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isPinned"
              checked={data?.isPinned || false}
              onChange={(e) =>
                onChange({ ...data, isPinned: e.target.checked })
              }
            />
            <label htmlFor="isPinned">Fixar no topo</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="sendNotification"
              checked={data?.sendNotification || false}
              onChange={(e) =>
                onChange({ ...data, sendNotification: e.target.checked })
              }
            />
            <label htmlFor="sendNotification">Enviar notificação</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="requireConfirmation"
              checked={data?.requireConfirmation || false}
              onChange={(e) =>
                onChange({ ...data, requireConfirmation: e.target.checked })
              }
            />
            <label htmlFor="requireConfirmation">Requer confirmação de leitura</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip school_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
          <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z" />
        </svg>
        <span>
          Publique comunicados oficiais da instituição. Ideal para
          matrículas, eventos e avisos importantes.
        </span>
      </div>
    </div>
  );
}
